/* tslint:disable */
/* eslint-disable */
/**
 * CyberWell Aegis API
 * Multi-tenant case management API with JWT auth, RBAC (Casbin), audit logging, and tenant isolation.
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface FindingDto
 */
export interface FindingDto {
    /**
     * 
     * @type {string}
     * @memberof FindingDto
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof FindingDto
     */
    uuid?: string;
    /**
     * 
     * @type {string}
     * @memberof FindingDto
     */
    title?: string;
    /**
     * 
     * @type {string}
     * @memberof FindingDto
     */
    description?: string;
    /**
     * 
     * @type {string}
     * @memberof FindingDto
     */
    assessmentStatus?: string;
    /**
     * 
     * @type {boolean}
     * @memberof FindingDto
     */
    hasExistingPoamItemForControl?: boolean;
    /**
     * 
     * @type {Array<string>}
     * @memberof FindingDto
     */
    existingPoamItemIds?: Array<string>;
}

/**
 * Check if a given object implements the FindingDto interface.
 */
export function instanceOfFindingDto(value: object): value is FindingDto {
    return true;
}

export function FindingDtoFromJSON(json: any): FindingDto {
    return FindingDtoFromJSONTyped(json, false);
}

export function FindingDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): FindingDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'uuid': json['uuid'] == null ? undefined : json['uuid'],
        'title': json['title'] == null ? undefined : json['title'],
        'description': json['description'] == null ? undefined : json['description'],
        'assessmentStatus': json['assessmentStatus'] == null ? undefined : json['assessmentStatus'],
        'hasExistingPoamItemForControl': json['hasExistingPoamItemForControl'] == null ? undefined : json['hasExistingPoamItemForControl'],
        'existingPoamItemIds': json['existingPoamItemIds'] == null ? undefined : json['existingPoamItemIds'],
    };
}

export function FindingDtoToJSON(json: any): FindingDto {
    return FindingDtoToJSONTyped(json, false);
}

export function FindingDtoToJSONTyped(value?: FindingDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'uuid': value['uuid'],
        'title': value['title'],
        'description': value['description'],
        'assessmentStatus': value['assessmentStatus'],
        'hasExistingPoamItemForControl': value['hasExistingPoamItemForControl'],
        'existingPoamItemIds': value['existingPoamItemIds'],
    };
}

